// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","tabsContainer":"tabsContainer-2G9Hl tabsContainer-cJOxE","tab":"tab-2Dol5 tab-2GJzS","tabActive":"tabActive-2JvED tabActive-3rQTb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/_homeHeader.css
// module id = 1207
// module chunks = 1